import { useEffect, useState, useCallback } from 'react';
import { pb, getFileUrl } from '../lib/pb';

export function useAuth(){
  const [model, setModel] = useState(pb.authStore.model || null);
  const [token, setToken] = useState(pb.authStore.token || '');

  useEffect(() => {
    const unsub = pb.authStore.onChange((t, m) => {
      setToken(t || '');
      setModel(m || null);
    });
    return () => unsub?.();
  }, []);

  const isLogged = !!token && !!model;
  const role = model?.role || 'user';
  const isAdmin = role === 'admin';
  const avatarUrl = model?.avatar ? getFileUrl(model, model.avatar) : '';

  const login = useCallback(async (identity, password) => {
    await pb.collection('users').authWithPassword(identity, password);
  }, []);

  const register = useCallback(async ({ email, name, password, passwordConfirm }) => {
    await pb.collection('users').create({
      email,
      name,
      password,
      passwordConfirm: passwordConfirm || password,
      emailVisibility: true,
    });
  }, []);

  const logout = useCallback(() => {
    pb.authStore.clear();
    setModel(null);
    setToken('');
  }, []);

  return { model, token, isLogged, isAdmin, role, avatarUrl, login, register, logout };
}
